import * as React from 'react';
import Box from '@mui/material/Box';
import {
  Button, IconButton, Typography,
  // ListItemIcon, MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
// import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

export default function RenameScreener({ renamePreset, renameDialog, setBanner, isPremium, userUpdatedPreset, activePresetName, activePresetDesc, activePresetCode, handleRenameClose }) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [screenerName, setScreenerName] = React.useState(activePresetName);
  const [screenerDesc, setScreenerDesc] = React.useState(activePresetDesc);
  const [screenerCode, setScreenerCode] = React.useState(activePresetCode);
  const [labelText, setLabelText] = React.useState('New Screener Name');
  const [labelDescText, setLabelDescText] = React.useState('Description');

  const handleDialogOpen = () => {
    // handleMenuClose()
    if (isPremium) {
      setOpen(true);
    } else {
      setBanner(true);
    }
  };

  const handleDialogClose = () => {
    setOpen(false);
    setLoading(false)
  };

  const handlePresetName = (event) => {
    event.preventDefault();
    setLoading(true)
    renamePreset(screenerName, screenerDesc, screenerCode)
  }

  // const handleInputChange = (event) => {
  //   const input = event.target.value;
  //   const regex = /^[a-zA-Z0-9]*$/; // Regex to allow only letters and numbers
  //   if (input.length > 0 && input[0] === ' ') { // Check if first character is a space
  //     setLabelText('Space cannot be the first character');
  //   } else if (regex.test(input)) {
  //     setScreenerName(input);
  //     setLabelText('New Screener Name');
  //   } else {
  //     setLabelText('Spaces and special characters are not allowed');
  //   }
  // };

  // const handleInputChange = (event) => {
  //   const input = event.target.value;
  //   if (input.length > 0 && input[0] === ' ') {
  //     setLabelText('Text should not start with a space');
  //   } else if (/^[a-zA-Z0-9\s]*$/.test(input)) {
  //     setLabelText('New Screener Name');
  //     setScreenerName(input);
  //   } else if (/^[:"!@#\$&'()*]*$/.test(input)) {
  //     setLabelText('Spaces and special characters are not allowed');
  //     setScreenerName(input);
  //   } else {
  //     setLabelText('Invalid Input');
  //   }
  // };

  const handleInputChange = (event) => {
    const input = event.target.value;
    if (input.length > 0 && input[0] === ' ') {
      setLabelText('Text should not start with a space');
    } else if (/.*/.test(input)) { // Match any character
      setLabelText('New Screener Name');
      setScreenerName(input);
    } else {
      setLabelText('Invalid Input');
    }
  };

  const handleInputDescChange = (event) => {
    const input = event.target.value;
    // const regex = /^[a-zA-Z0-9 ]*$/; // Regex to allow letters, numbers, and spaces
    if (input.length > 0 && input.trim() === '') { // Check if the input consists of only spaces
      setLabelDescText('Space cannot be the first character');
    } else if (/.*/.test(input)) {
      setScreenerDesc(input);
      setLabelDescText('Description');
    } else {
      setLabelDescText('Special characters are not allowed');
    }
  };

  React.useEffect(() => {
    setOpen(false)
    setLoading(false)
  }, [userUpdatedPreset,])

  React.useEffect(() => {
    setScreenerName(activePresetName)
    setScreenerDesc(activePresetDesc)
    setScreenerCode(activePresetCode)
  }, [activePresetDesc, activePresetName])

  React.useEffect(() => {
    setOpen(renameDialog)
  }, [renameDialog])

  return (
    <>
      {/* <LightTooltip describeChild title="Save as Preset" placement="top" disableInteractive>
        <IconButton onClick={handleDialogOpen} sx={{ mr: .6 }}>
          <SaveOutlinedIcon fontSize="small" sx={{ color: '#434166' }} />
        </IconButton>
      </LightTooltip> */}
      {/* <MenuItem onClick={handleDialogOpen}>
        <ListItemIcon>
          <PlaylistAddRoundedIcon fontSize="small" sx={{ color: 'primary.main' }} />
        </ListItemIcon>
        <Typography variant="inherit" noWrap sx={{ color: 'primary.main', fontSize: '.95rem', }}>Rename Screen</Typography>
      </MenuItem> */}
      {/* <Button
        onClick={handleDialogOpen}
        size="small"
        variant="text"
        sx={{
          color: 'primary.main', fontSize: '.875rem',
          textTransform: 'none', mx: 2,
          // width: { xs: '100%' }, whiteSpace: 'nowrap'
        }}>
        Save Query
      </Button> */}
      <Dialog open={open} onClose={() => { handleRenameClose(); setLoading(false) }}>
        {/* <DialogTitle>Save your favorite screener configurations</DialogTitle> */}
        <DialogContent>
          <DialogContentText sx={{ color: 'primary.main' }}>
            Please enter a new name for {activePresetName ? `"${activePresetName}":` : 'your screener:'}<br />
            {/* <Typography variant="body2" sx={{ color: '#555' }}>
              This new name will help you recognize it in your saved list of "Your Screens."
            </Typography><br /> */}
          </DialogContentText>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handlePresetName}
          >
            <TextField
              size="small"
              autoFocus
              margin="dense"
              id="name"
              helperText=""
              label={labelText}
              disabled={loading}
              type="text"
              error={labelText !== 'New Screener Name'}
              fullWidth
              variant="standard"
              value={screenerName}
              onChange={handleInputChange}
              inputProps={{ maxLength: 30 }} // Limit the input to 30 characters
              sx={{ mt: 2 }}
            />
            <TextField
              size="small"
              // autoFocus
              margin="dense"
              id="desc"
              helperText=""
              label={labelDescText}
              disabled={loading}
              type="text"
              fullWidth
              error={labelDescText !== 'Description'}
              variant="standard"
              value={screenerDesc}
              onChange={handleInputDescChange}
              inputProps={{ maxLength: 100 }} // Limit the input to 30 characters
              sx={{ mt: 2 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} size="small" sx={{ textTransform: 'none' }} onClick={handleRenameClose}>Cancel</Button>
          <Button size="small" disabled={screenerName === "" || loading} variant="contained" sx={{ textTransform: 'none' }} onClick={handlePresetName}>{loading ? `Loading...` : `Rename Screen`}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
